import { useEffect, useState } from 'react' 
import { getDiffFromTwoTime } from '../utils/helper'
import moment from 'moment-timezone'

export const useCountDown = (screen) => {
    const [days, setDays] = useState('00')
    const [hours, setHours] = useState('00')
    const [minutes, setMinutes] = useState('00')
    const [seconds, setSeconds] = useState('00')
    const [timerClean, setTimerClean] = useState(0)

    let checkoutTime = 0
    let facilityTimeZone='America/New_York'
    let is_multiday_parking = null
    if(screen == 'extend'){
        const data = JSON?.parse(localStorage?.getItem('ExtendData'))
        checkoutTime = data?.checkout_datetime
        facilityTimeZone = data?.facility?.timezone || 'America/New_York'
        is_multiday_parking = data?.facility?.is_multiday_parking || '0'
    }else{
        const data = JSON.parse(localStorage?.getItem('paymentRecipt'))
        checkoutTime = data?.checkout_datetime
        facilityTimeZone = data?.facility?.timezone || 'America/New_York'
        is_multiday_parking = data?.facility?.is_multiday_parking || '0'
    }

    useEffect(() => {
        // Store the checkout time in localStorage for persistence
        localStorage.setItem('checkoutTime', checkoutTime)

        const updateTimer = () => {
            const storedCheckoutTime = localStorage.getItem('checkoutTime') || checkoutTime
            const distance = moment(storedCheckoutTime).diff(
                moment(new Date()).tz(facilityTimeZone).format('YYYY-MM-DD HH:mm:ss'), 
                'seconds'
            )

            const locminutes = getDiffFromTwoTime(storedCheckoutTime, screen)

            if(locminutes > 0){
                if(is_multiday_parking == '1'){
                    setDays(Math.floor(locminutes / (24 * 60)))
                    setHours(Math.floor((locminutes % (24 * 60)) / 60))
                } else {
                    setHours(Number(Math.floor(locminutes / (24 * 60)) * 24) + Number(Math.floor((locminutes % (24 * 60)) / 60)))
                }
                setMinutes(Math.floor(locminutes % 60))
                setSeconds(distance % 60)
            } else if ( locminutes == 0 ) {
                setMinutes(0)
                setSeconds(0)
            }

                
            // If the count down is over, write some text 
            if (locminutes < 0) {
                setTimerClean(prev => prev + 1)
                if (timerClean > 0) {
                    clearInterval(interval)
                }
            }
        }

        updateTimer() // Initial update

        const interval = setInterval(updateTimer, 1000)

        // Handle browser visibility change (for iOS Safari issue)
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                updateTimer() // Recalculate when browser is reopened
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            clearInterval(interval)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    },[days, hours, minutes, seconds])

    return [days, hours, minutes, seconds]
}